module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderList"
  }, [_c('span', {
    staticClass: "orderList_all_total"
  }, [_vm._v("金额合计：" + _vm._s(_vm.allTotal / 100) + " 元")]), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "户号"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "户号",
      "maxlength": 12
    },
    model: {
      value: (_vm.formInline.account),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "account", $$v)
      },
      expression: "formInline.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "表号"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "表号",
      "maxlength": 12
    },
    model: {
      value: (_vm.formInline.code),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "code", $$v)
      },
      expression: "formInline.code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "表类型"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formInline.typess),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "typess", $$v)
      },
      expression: "formInline.typess"
    }
  }, _vm._l((_vm.typess), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.label,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "业主类型"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formInline.nature),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "nature", $$v)
      },
      expression: "formInline.nature"
    }
  }, _vm._l((_vm.natures), function(item) {
    return _c('el-option', {
      key: item.num,
      attrs: {
        "label": item.value,
        "value": item.num
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "业主姓名"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "业主姓名"
    },
    model: {
      value: (_vm.formInline.owner_name),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "owner_name", $$v)
      },
      expression: "formInline.owner_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "地址"
    },
    model: {
      value: (_vm.formInline.address),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "address", $$v)
      },
      expression: "formInline.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "充值时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择开始日期"
    },
    model: {
      value: (_vm.formInline.value2),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "value2", $$v)
      },
      expression: "formInline.value2"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择结束日期"
    },
    model: {
      value: (_vm.formInline.value3),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "value3", $$v)
      },
      expression: "formInline.value3"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支付方式"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formInline.type),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "type", $$v)
      },
      expression: "formInline.type"
    }
  }, _vm._l((_vm.types), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.resetting
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.downorderCode()
      }
    }
  }, [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "1777px",
      "text-align": "center",
      "margin-bottom": "10px",
      "font-size": "12px"
    },
    attrs: {
      "data": _vm.orderList,
      "border": ""
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "order_code",
      "label": "订单编号",
      "align": "center",
      "width": "190",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "account",
      "label": "户号",
      "width": "125",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "meter_code",
      "label": "表号",
      "width": "125",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tra_type",
      "label": "表类型",
      "width": "100",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total",
      "formatter": _vm.formatter,
      "label": "充值金额(元)",
      "width": "130",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "充值水量（吨）",
      "width": "145",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nature",
      "label": "业主类型",
      "width": "110",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "owner_name",
      "label": "业主姓名",
      "width": "130",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "地址",
      "width": "370",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pay_type",
      "label": "支付方式",
      "width": "120",
      "align": "center",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(1 == scope.row.pay_type) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("支付宝")]) : _vm._e(), _vm._v(" "), (2 == scope.row.pay_type) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("微信")]) : _vm._e(), _vm._v(" "), (3 == scope.row.pay_type) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("银联")]) : _vm._e(), _vm._v(" "), (4 == scope.row.pay_type) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("现金")]) : _vm._e(), _vm._v(" "), (5 == scope.row.pay_type) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("支票")]) : _vm._e(), _vm._v(" "), (6 == scope.row.pay_type) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("光大银行")]) : _vm._e(), _vm._v(" "), (7 == scope.row.pay_type) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("直充")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "创建日期",
      "width": "230",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sumbit",
      "width": "100",
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.onToSmallChange(scope.row.order_id, scope.row.cycle)
            }
          }
        }, [_vm._v("详情")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "page-size": _vm.pageSize,
      "layout": "total,prev, pager, next",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), (_vm.detailsShow) ? _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "details_back"
  }), _vm._v(" "), _c('div', {
    staticClass: "details_main"
  }, [_c('div', {
    staticClass: "details_main_item"
  }, [_c('label', [_vm._v("户号：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.details.account))])]), _vm._v(" "), _c('div', {
    staticClass: "details_main_item"
  }, [_c('label', [_vm._v("表号：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.details.meter_code))])]), _vm._v(" "), _c('div', {
    staticClass: "details_main_item"
  }, [_c('label', [_vm._v("业主名称：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.details.owner_name))])]), _vm._v(" "), _c('div', {
    staticClass: "details_main_item"
  }, [_c('label', [_vm._v("地址：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.details.address))])]), _vm._v(" "), _c('div', {
    staticClass: "details_main_item"
  }, [_c('label', [_vm._v("支付方式：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.details.pay_type == 1 ? '支付宝' : _vm.details.pay_type == 2 ? '微信支付' : _vm.details.pay_type == 3 ? '银联' : _vm.details.pay_type == 4 ? '现金' : _vm.details.pay_type == 5 ? '支票' : _vm.details.pay_type == 6 ? '光大银行' : '直充'))])]), _vm._v(" "), _c('div', {
    staticClass: "details_main_item"
  }, [_c('label', [_vm._v("支付前余额：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("￥" + _vm._s(_vm.details.before_blance))])]), _vm._v(" "), (_vm.isYear) ? _c('div', {
    staticClass: "details_main_item"
  }, [_c('label', [_vm._v("支付前本年用量：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.details.yeartotal) + "度")])]) : _vm._e(), _vm._v(" "), (_vm.isYear) ? _c('div', {
    staticClass: "details_main_item"
  }, [_c('label', [_vm._v("入表金额：")]), _vm._v(" "), _c('span', {
    staticClass: "content content_red"
  }, [_vm._v("￥" + _vm._s(_vm.details.meter_money))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details_main_item"
  }, [_c('label', [_vm._v("支付金额：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("￥" + _vm._s(_vm.chu(_vm.details.total)))])]), _vm._v(" "), (_vm.isYear) ? _c('div', {
    staticClass: "details_main_item"
  }, [_c('label', [_vm._v("补交阶梯差价：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("￥" + _vm._s(_vm.details.diff_money))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": '/explain/explain-detailed?yeartotal=' + _vm.details.yeartotal + '&newyear=' + 1,
      "target": "_blank"
    }
  }, [_vm._v("说明")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details_main_item"
  }, [_c('label', [_vm._v("透支金额：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("￥" + _vm._s(_vm.details.over_money))])]), _vm._v(" "), (_vm.isYear) ? _c('div', {
    staticClass: "details_main_item"
  }, [_c('label', [_vm._v("存入零钱：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("￥" + _vm._s(_vm.details.pocket_in))])]) : _vm._e(), _vm._v(" "), (_vm.isYear) ? _c('div', {
    staticClass: "details_main_item"
  }, [_c('label', [_vm._v("本次充值后零钱余额：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("￥" + _vm._s(_vm.details.pocket_after))])]) : _vm._e(), _vm._v(" "), (_vm.isYear) ? _c('div', {
    staticClass: "details_main_item"
  }, [_c('label', [_vm._v("本次充值后零钱支付：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("￥" + _vm._s(_vm.details.pocket_out))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details_main_item"
  }, [_c('label', [_vm._v("支付后电表余额：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.details.after_blance))])]), _vm._v(" "), _c('div', {
    staticClass: "details_main_item"
  }, [_c('label', [_vm._v("支付时间：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.details.create_time))])]), _vm._v(" "), _c('div', {
    staticClass: "details_main_item"
  }, [_c('label', [_vm._v("充值状态：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.details.status))])]), _vm._v(" "), _c('div', {
    staticClass: "details_main_buttonGroup"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "round": ""
    },
    on: {
      "click": function($event) {
        _vm.detailsShow = false
      }
    }
  }, [_vm._v("关闭")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-3cf2ddf0"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderList.vue
// module id = 526
// module chunks = 1